import { takeLatest } from 'redux-saga/effects';
import { GET_CURRENT_USER } from '../../store/user/actions';
import { fetchCurrentUserSaga } from '../../store/user/saga';

export default function* appSaga() {
  yield takeLatest(GET_CURRENT_USER, fetchCurrentUserSaga);
}
